
import { useEffect } from 'react';
import { useFirebase } from '@/context/FirebaseProvider'; // Replaced useDataUtils
import { useToast } from './use-toast';
import { Business, Portfolio } from '@/schemas'; // Assuming Zod types

export const useBusinessUtils = () => {
  const { businesses, portfolios } = useFirebase(); // Get data from FirebaseProvider
  const { toast } = useToast();
  
  // Get all businesses across all portfolios
  const getAllBusinesses = () => {
    return businesses || [];
  };
  
  // Get businesses for a specific portfolio
  const getBusinessesForPortfolio = (portfolioId: string) => {
    if (!businesses) return [];
    return businesses.filter(business => business.portfolioId === portfolioId);
  };
  
  // Debug function to check business data
  const debugBusinessData = () => {
    console.log("All portfolios from FirebaseProvider:", portfolios);
    
    if (!portfolios || portfolios.length === 0) {
      console.log("No portfolios found");
      return {
        portfolioCount: 0,
        businessCount: 0,
        portfolioDetails: []
      };
    }
    
    portfolios.forEach(portfolio => {
      if (!portfolio) {
        console.log("Found an undefined portfolio");
        return;
      }
      
      // Get businesses for this portfolio
      const businessesInPortfolio = businesses?.filter(b => b.portfolioId === portfolio.id) || [];
      const businessCount = businessesInPortfolio.length;
      console.log(`Portfolio ${portfolio.id} (${portfolio.name || 'Unnamed'}) has ${businessCount} businesses`);
      
      businessesInPortfolio.forEach(business => {
        if (!business) {
          console.log(`- Found an undefined business in portfolio ${portfolio.id}`);
          return;
        }
        console.log(`- Business ${business.id}: ${business.name || 'Unnamed'}`); // Assuming business.name from Zod
      });
    });
    
    const allCurrentBusinesses = getAllBusinesses();
    console.log(`Total businesses across all portfolios: ${allCurrentBusinesses.length}`);
    
    return {
      portfolioCount: portfolios?.length || 0,
      businessCount: allCurrentBusinesses.length,
      portfolioDetails: portfolios?.map(p => ({ 
        id: p.id, 
        name: p.name || 'Unnamed', 
        businessCount: businesses?.filter(b => b.portfolioId === p.id).length || 0
      })) || []
    };
  };
  
  // Verify business exists in data
  const verifyBusinessExists = (businessId: string) => {
    if (!businesses) return false;
    return businesses.some(business => business.id === businessId);
  };
  
  return {
    getAllBusinesses,
    getBusinessesForPortfolio,
    debugBusinessData,
    verifyBusinessExists,
    // Removed ...dataUtils spread. Consumers needing other utils must be refactored.
  };
};
